customElements.whenDefined('header-menu').then(() => {
  if (window.innerWidth >= 990) {
    document.querySelectorAll('header-menu').forEach((headerMenu) => {
      const details = headerMenu.querySelector('details.mega-menu');
      if (!details) return;

      const megaContent = details.querySelector('.mega-menu__content');
      let closeTimer = null;

      const openMenu = () => {
        clearTimeout(closeTimer);
        details.setAttribute('open', '');
      };

      const closeMenu = () => {
        closeTimer = setTimeout(() => {
          details.removeAttribute('open');
        }, 150);
      };

      headerMenu.addEventListener('mouseenter', openMenu);
      headerMenu.addEventListener('mouseleave', closeMenu);

      if (megaContent) {
        megaContent.addEventListener('mouseenter', openMenu);
        megaContent.addEventListener('mouseleave', closeMenu);
      }
    });
  }
});

/*Max 2026.04.13*/